import { render, staticRenderFns } from "./RichPage.vue?vue&type=template&id=918a5798&scoped=true"
import script from "./RichPage.vue?vue&type=script&lang=js"
export * from "./RichPage.vue?vue&type=script&lang=js"
import style0 from "./RichPage.vue?vue&type=style&index=0&id=918a5798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918a5798",
  null
  
)

export default component.exports